(function() {
'use strict';

/* global L */
const TR = angular.module('TR');
TR.directive('leafletMap', function($window, $timeout, searchUnitService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            key: '@',
            model: '='
        },
        template: '<div><div>',
        link(scope, el) {
            const headerHeight = 95;
            const throttle = 100;
            const pos = searchUnitService.getSearchArea();
            let map;
            let initialised = false;
            let centre;
            let promise = null;

            scope.$on('mapTabSelected', function() {
                if (!$window.L) {
                    $('<link rel=\'stylesheet\' href=\'build/vendor/leaflet/leaflet.css\' />')
                        .appendTo($('head'));

                    $.getScript('build/vendor/leaflet/leaflet.js', function() {
                        $timeout($window.mapLoadedCallback, 50);
                    });
                } else {
                    $timeout($window.mapLoadedCallback, 50);
                }
            });

            scope.$on('$destroy', function() {
                delete $window.mapLoadedCallback;
                $($window).off('resize', windowResize);
            });

            function windowResize() {
                if (promise !== null) {
                    $timeout.cancel(promise);
                    promise = null;
                }
                promise = $timeout(resizeMap, throttle);
            }

            $window.mapLoadedCallback = function() {
                if (!initialised && !map) {
                    resizeMap();

                    centre = [scope.model.Latitude, scope.model.Longitude];

                    map = L.map(el[0], {
                        center: centre,
                        zoom: scope.model.ZoomLevel || 15,
                        scrollWheelZoom: false
                    });

                    L.control.scale({ position: 'bottomright' }).addTo(map);

                    L.tileLayer(`https://ssl_tiles.cloudmade.com/${scope.key}/997/256/{z}/{x}/{y}.png`, {
                        attribution: 'Map data &copy; OpenStreetMap contributors, Imagery &copy; CloudMade',
                        name: 'Map'
                    }).addTo(map);

                    const hotelIcon = L.icon({
                        iconUrl: 'build/img/Maps/hotel-pin.png',
                        shadowUrl: 'build/img/Maps/hotel-pin-shadow.png',
                        iconSize: [46, 57],
                        iconAnchor: [23, 56],
                        popupAnchor: [0, -56]
                    });

                    const bounds = [centre];

                    L.marker(centre, { icon: hotelIcon }).addTo(map)
                        .bindPopup(scope.model.Title)
                        .openPopup();

                    if (pos) {
                        const me = [pos.Latitude, pos.Longitude];

                        L.marker(me, { icon: L.icon({
                            iconUrl: 'build/img/Maps/marker-icon.png',
                            shadowUrl: 'build/img/Maps/marker-shadow.png',
                            iconSize: [25, 41],
                            iconAnchor: [12, 41],
                            popupAnchor: [0, -41]
                        }) }).addTo(map);

                        bounds.push(me);
                    }

                    map.fitBounds(bounds);
                    $($window).on('resize', windowResize);
                    initialised = true;
                } else {
                    resizeMap();
                }
            };

            function resizeMap() {
                el.width('100%');
                el.height($($window).height() - headerHeight);
                if (map) {
                    map.invalidateSize();
                }
            }
        }
    };
});
})();
